/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestModel } from '@app/sales/requests/request.model';
import { RequestsFormComponent } from '@app/sales/requests/requests-form/requests-form.component';

@Injectable({
  providedIn: 'root',
})
export class RequestsFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open request form
   * @param request RequestModel
   */
  public open(request: null | RequestModel = null): Promise<any> {
    const modal = this.modalService.open(RequestsFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.request = request;
    return modal.result;
  }
}
